<template>
    <Form @submit="onSubmit" v-slot="{ errors }" @invalid-submit="onInvalidSubmit">
        <div class="flex flex-col">
            <div>
                <div class="mb-10  last:mb-0">
                    <h2 class="text-dark-550  dark:text-white font-bold flex items-center text-xl">
                        <i class="w-2 h-2 bg-gray-350 dark:bg-white ml-2 rounded-full "></i>
                        {{ state }}
                    </h2>
                    <div class="divider col-span-full mt-0 mb-3"></div>
                    <div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 1">
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Opportunity name') }} <span class="text-error">*</span>
                                </label>
                                <Field v-model="opportunity.name" rules="required"
                                    :class="{ 'input-error': errors.name }" class="input" type="text" name="name" />
                            </div>
                               <div class="flex flex-col">
                                    <div class="flex justify-between">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                        {{ __('Person') }} <span class="text-error">*</span>
                                    </label>
                                    <button type="button" class="text-blue-400 hover:text-blue-500 text-xs font-semibold" @click="setModal('add-person-modal')" v-if="!opportunity.id">{{ __('Create person') }}</button>
                                    </div>
                                    <Field name="person_id" v-slot="{ field }"
                                        rules="required" v-model="opportunity.person_id">
                                        <v-select dir="rtl" :options="meta.person" :reduce="(option) => option.id"
                                            @update:modelValue="val => opportunity.person_id = val" :modelValue="field.value ? parseInt(field.value) : null"
                                            :placeholder="__('Select...')" v-bind="field" class="input" :filterable="false" :clearable="false"
                                            :class="{ 'input-error': errors.person_id }" @search="fetchOptions({ search: $event }, 'person')"
                                            :loading="meta.type == 'person' && loadingBtn" :getOptionLabel="(option) => option.name ?? __('Select...')">
                                            <template #no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    <div class="opacity-60">{{ __('Nothing found to display') }}.</div>
                                                </template>
                                                <div v-else class="opacity-60">{{ __('Start typing to search for a user')
                                                    }}.</div>
                                            </template>
                                        </v-select>
                                    </Field>
                                </div>
                                <div class="flex flex-col">
                                    <div class="flex justify-between">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                        {{ __('Account name') }}
                                    </label>
                                    <button class="text-blue-400 hover:text-blue-500 text-xs font-semibold" type="button" @click="setModal('add-account-modal')" v-if="!opportunity.id">{{ __('Create account') }}</button>
                                    </div>
                                    <Field name="account_id" v-slot="{ field }"
                                        v-model="opportunity.account_id">
                                        <v-select dir="rtl" :options="meta.account" :reduce="(option) => option.id" @update:modelValue="val => opportunity.account_id = val" :modelValue="field.value ? parseInt(field.value) : null"
                                            :placeholder="__('Select...')" v-bind="field" class="input" :filterable="false" :clearable="false"
                                            :class="{ 'input-error': errors.account_id }" @search="fetchOptions({ search: $event }, 'account')"
                                            :loading="meta.type == 'account' && loadingBtn" :getOptionLabel="(option) => option.name ?? __('Select...')">
                                            <template #no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    <div class="opacity-60">{{ __('Nothing found to display') }}.</div>
                                                </template>
                                                <div v-else class="opacity-60">{{ __('Start typing to search for a user')
                                                    }}.</div>
                                            </template>
                                        </v-select>
                                    </Field>
                                </div>
                                                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Lead source') }}
                                </label>
                                <Field as="select" v-model="opportunity.lead_source_id"
                                    :class="{ 'input-error': errors.lead_source_id }" class="select" name="lead_source_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.lead_sources" :value="item.id">{{ item.title }}
                                    </option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex justify-between">
                                                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Amount') }} <span class="text-error">*</span>
                                </label>
<button class="text-blue-400 hover:text-blue-500 text-xs font-semibold" type="button" @click="setStep(3)" >{{ __('Add products') }}</button>
                                </div>
                                <Field v-model="opportunity.amount" :class="{ 'input-error': errors.amount }"
                                    class="input" type="number" name="amount" rules="required" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Currency') }} <span class="text-error">*</span>
                                </label>
                                <Field as="select" v-model="opportunity.currency" rules="required"
                                    :class="{ 'select-error': errors.currency }" class="select" name="currency">
                                    <option v-for="item in meta.currency_types" :value="item">{{ __(item.capitalize()) }}
                                    </option>
                                </Field>
                            </div>
 <div class="flex flex-col">
                                <div class="flex justify-between">
                                                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Exchange rate') }} <span class="text-error">*</span>
                                </label>
                                </div>
                                <Field v-model="opportunity.exchange_rate" :class="{ 'input-error': errors.exchange_rate }" :readOnly="['toman','rial'].includes(opportunity.currency)"
                                    class="input" type="number"   step="0.01" name="exchange_rate" rules="required" />
                            </div>
                             <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Sale route') }} <span class="text-error">*</span>
                                </label>
                                <Field as="select" v-model="opportunity.sale_route_id" rules="required"
                                    :class="{ 'input-error': errors.sale_route_id }" class="select" name="sale_route_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.sale_routes" :value="item.id">
                                        {{ item.title }}
                                        </option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Sales stage') }} <span class="text-error">*</span>
                                </label>
                                <Field as="select" v-model="opportunity.sale_process_id" rules="required"
                                    :class="{ 'input-error': errors.sales_proccess_id }" class="select" name="sales_proccess_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in getSaleProcesses()" :value="item.id">
                                        {{ item.title }}
                                        </option>
                                </Field>
                            </div>

                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Status') }}
                                </label>
                                <Field as="select" v-model="opportunity.status" :class="{ 'input-error': errors.status }"
                                    class="select" name="status">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option value="completed">{{ __('Closed won') }}</option>
                                    <option value="failed">{{ __('Closed lost') }}</option>
                                </Field>
                            </div>
                              <div class="flex flex-col" v-if="opportunity.status == 'failed'">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('The reason for the loss') }}
                                </label>
                                <Field as="select" v-model="opportunity.failure_reason_id"
                                    :class="{ 'input-error': errors.failure_reason_id }" class="select" name="failure_reason_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.failure_reasons" :value="item.id">{{ item.title }}
                                    </option>
                                </Field>
                            </div>
                            <div class="flex flex-col" v-if="opportunity.status == 'completed'">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Sale date') }}
                                </label>
                                <Field v-model="opportunity.date_closed" name="date_closed" readonly
                                    class="input date_closed-input cursor-pointer"
                                    :class="{ 'input-error': errors.date_closed }" />
                                <DatePicker v-model="opportunity.date_closed" custom-input=".date_closed-input"
                                    type="date" />
                            </div>
                        </div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 2">
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Campaign') }}
                                </label>
                                <Field as="select" v-model="opportunity.campaign_id"
                                    :class="{ 'input-error': errors.campaign_id }" class="select" name="campaign_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.campaigns" :value="item.id">{{ item.name }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Priority') }}
                                </label>
                                <Field as="select" v-model="opportunity.priority"
                                    :class="{ 'input-error': errors.priority }" class="select" name="priority">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in priorityTypes" :value="item">{{
                                        __(item.replace('_', ' ').capitalize()) }}</option>
                                </Field>
                            </div>
                                                        <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Probability') }}
                                </label>
                                <Field v-model="opportunity.probability" :class="{ 'input-error': errors.probability }"
                                    class="input" type="text" name="probability" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Expected amount') }}
                                </label>
                                <Field v-model="opportunity.amount_expected"
                                    :class="{ 'input-error': errors.amount_expected }" class="input" type="number"
                                    name="amount_expected" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Type') }}
                                </label>
                                <Field as="select" v-model="opportunity.type" :class="{ 'input-error': errors.type }"
                                    class="select" name="type">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option value="existing_business">{{ __('Existing business') }}</option>
                                    <option value="new_business">{{ __('New business') }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Sales forecast') }}
                                </label>
                                <Field as="select" v-model="opportunity.forecast"
                                    :class="{ 'input-error': errors.forecast }" class="select" name="forecast">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option value="include">{{ __('Include') }}</option>
                                    <option value="exclude">{{ __('Exclude') }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Invoice sending periods') }}
                                </label>
                                <Field as="select" v-model="opportunity.invoicing_period"
                                    :class="{ 'input-error': errors.invoicing_period }" class="select"
                                    name="invoicing_period">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in periodTypes" :value="item">{{ __('Every') + ' ' + (item >= 12
                                        ? item / 12 : item) + ' ' + __(item >= 12 ? 'Year' : 'Month') }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('End date of the payment period') }}
                                </label>
                                <DatePicker v-model="opportunity.recurring_end_date" name="recurring_end_date"
                                    type="date" inputClass="input" />

                            </div>
                            <div class="flex flex-col col-span-full">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Description') }}
                                </label>
                                <Field as="textarea" v-model="opportunity.description"
                                    :class="{ 'input-error': errors.description }" class="textarea" type="text"
                                    name="description" />
                            </div>
                        </div>
                               <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 3">
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Product') }}
                                </label>
                                <Field name="product_id" v-slot="{ field }" v-model="opportunity.product_id">
                                    <v-select dir="rtl" :options="meta.product" :reduce="(option) => option.id" id="product_id"
                                        @option:selected="setItem" @update:modelValue="val => opportunity.product_id = val" :modelValue="field.value ? parseInt(field.value) : null"
                                        :placeholder="__('Select...')" v-bind="field" class="input" :filterable="false"
                                        @search="fetchOptions({ search: $event }, 'product')" :loading="loadingBtn" :getOptionLabel="(option) => option.name ?? __('Select...')">
                                        <template #no-options="{ search, searching }">
                                            <template v-if="searching">
                                                <div class="opacity-60">{{ __('Nothing found to display') }}.</div>
                                            </template>
                                            <div v-else class="opacity-60">{{ __('Start typing to search for a product')
                                                }}.</div>
                                        </template>
                                    </v-select>
                                </Field>
                            </div>
                            <div class="overflow-x-auto col-span-full">
                                <table class="table table-xs md:table-sm xl:table-md">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th> {{ __('Title') }} </th>
                                            <th> {{ __('sales price') }} </th>
                                            <th> {{ __('Count') }} </th>
                                            <th> {{ __('Discount') }} </th>
                                            <th> {{ __('Total') }} </th>
                                            <th> {{ __('Action') }} </th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in opportunity.items">
                                            <td> {{ index + 1 }} </td>
                                            <td> {{ item.title }} </td>
                                            <td> {{ item.sale_price.currency(opportunity.currency) }} </td>
                                            <td> {{ item.quantity + ' ' + __('Number') }} </td>
                                            <td> {{ calcDiscount(item).currency(opportunity.currency) }} </td>
                                            <td> {{ ((item.sale_price - calcDiscount(item)) * item.quantity).currency(opportunity.currency)
                                                }} </td>
                                            <td>
                                                <label @click="setProduct(item)" for="edit-modal"
                                                    class="btn btn-outline btn-info btn-sm mx-2">
                                                    {{ __('Edit') }}
                                                </label>
                                                <button @click="removeProduct(item.id)" type="button"
                                                    class="btn btn-outline btn-error btn-sm">
                                                    {{ __('Delete') }}
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="text-center" v-if="!opportunity.items.length">
                                        <tr>
                                            <td colspan="6">{{ __('No product selected.') }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                             <div class="overflow-x-auto col-span-full" v-if="opportunity.items.length">
                                <table class="table table-xs md:table-sm xl:table-md">
                                    <thead>
                                        <tr class="text-center">
                                            <th> {{ __('Total Amount') }} </th>
                                            <th> {{ __('Discount') }} </th>
                                            <th> {{ __('Final amount') }} </th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        <tr class="text-center">
                                            <td> {{ getTotal().currency(opportunity.currency) }} </td>
                                            <td> {{ getDiscount().currency(opportunity.currency) }} </td>
                                            <td> {{ getAmount().currency(opportunity.currency) }} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 4">
                            <div class="flex flex-col col-span-full">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('File') }}
                                </label>
                                <Field class="file-input pr-0" @change="addAttachment($event, 'attachment')" type="file"
                                    name="file" />
                            </div>
                            <div class="overflow-x-auto col-span-full">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{{ __('File title') }}</th>
                                            <th>{{ __('File type') }}</th>
                                            <th>{{ __('Status') }}</th>
                                            <th>{{ __('Action') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in opportunity.attachments">
                                            <th>{{ index + 1 }}</th>
                                            <th>{{ item.name }}</th>
                                            <td>{{ item.mime_type }}</td>
                                            <td>
                                                <div v-if="isNumeric(item.status)">
                                                    <progress class="progress progress-info w-16" :value="item.status"
                                                        max="100"></progress> <span class="mr-0.5 inline-block w-4">{{
                                                        item.status + '%' }}</span>
                                                </div>
                                                <div v-else>{{ __(item.url ? 'Uploaded' : 'Uploading') }}</div>
                                            </td>
                                            <td>
                                                <button @click="removeFile(opportunity.attachments, index)" type="button"
                                                    class="btn btn-outline btn-error btn-sm">
                                                    {{ __('Delete') }}
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="text-center" v-if="!opportunity.attachments.length">
                                        <tr>
                                            <td colspan="5">{{ __('No file found to display') }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider h-auto w-full"></div>
            <div class="text-end">
                <button type="submit" class="btn btn-primary px-6 mr-2">{{
                    __('Save Changes')
                    }}</button>
            </div>
        </div>
    </Form>
    <ProductUpdateModal :product="product" v-if="product.id" @updateItem="updateItem" />
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';

import DatePicker from 'vue3-persian-datetime-picker'
import { Field, Form } from "vee-validate";
const props = defineProps(['opportunity', 'step', 'state','modal']);
const emit = defineEmits(['setModal','setStep']);
const priorityTypes = ['very_high', 'high', 'medium', 'low', 'very_low'];
const periodTypes = ['1', '2', '3', '4', '6', '12'];
const product = ref({});
const { uploadFile, removeFile, opportunity, storeOpportunity, updateOpportunity,loadingBtn,fetchOptions,meta } = useDashboard();
watch(
  () => props.opportunity,
  (val) => {
    Object.assign(opportunity, val)
  },
  { immediate: true, deep: true }
)
const addAttachment = (event, type) => {
    opportunity.attachments = [...opportunity.attachments, { title: event.target.files[0].name, type: 'attachment', status: 'uploading' }];
    uploadFile(event, type, opportunity.attachments[opportunity.attachments.length - 1]);
}
const calcDiscount = (item) => {
    let amount = item.discount;
    if (item.discount && item.discount_type == 'percent') amount = item.discount * item.sale_price / 100;
    return amount;
}
const getTotal = () => opportunity.items?.reduce((carry, item) => carry + (item.sale_price * item.quantity), 0);
const getDiscount = () => opportunity.items.reduce((carry, item) => carry + (calcDiscount(item) * item.quantity), 0);
const getAmount = () => opportunity.items.reduce((carry, item) => {
    return carry + parseInt((item.sale_price - calcDiscount(item)) * item.quantity)}, 0);
const setModal = (modal) => emit('setModal',modal);
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
const updateItem = (p) => {
    const item = opportunity.items.find(item => item.id == product.value.id);
    Object.assign(item, p);
    document.getElementById('edit-modal').checked = false;
    product.value = {};
}
const setStep = (step) => emit('setStep',step);
const removeProduct = (productId) => {
    opportunity.items = opportunity.items.filter(item => item.id != productId);
}
watch(() => opportunity.items,() => {
    const amount = getAmount();
    if(amount > 0)opportunity.amount = amount;
},{immediate: true});
watch(() => opportunity.currency,(value) => {
    opportunity.exchange_rate = value == 'toman' ? 1 : value == 'rial' ? 0.1 : '';
});
const setProduct = (p) => product.value = p;
const setItem = (product) => {
    const isItem = opportunity.items.find(item => item.product_id == product.id);
    if (!isItem) opportunity.items = [
        ...opportunity.items,
        { ...product, product_id: product.id, title: product.name, quantity: 1, discount_type: 'percent', discount: 0 }
    ];
    opportunity.product_id = null;
}
const getSaleProcesses = () => meta.sale_routes?.find(item => item.id == opportunity.sale_route_id)?.items || []

const onSubmit = () => {
    if (opportunity.id) updateOpportunity(props.modal);
    else storeOpportunity(props.modal);
}
const onInvalidSubmit = ({ errors }) => {
 setStep(1);
};
</script>